import { h } from 'preact';
import { Text } from 'preact-i18n';
import { selectIcon } from '../../../templates/place';
import MundialButton from '../../MundialButton';

const DateOption = ({ label, onClick, icon }) => {
  const handleClick = (e) => {
    e.stopPropagation(); // Prevent event from bubbling to parent wrapper
    onClick(e);
  };
  
  return (
    <button className="dates-controls-button" onClick={handleClick}>
      {icon && (
        <div
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: selectIcon('calendar', false),
          }}
        />
      )}
      {label}
    </button>
  );
};

const DatesControls = ({ label, onDateClick, onTodayClick, onTomorrowClick, onMundialClick, showMundialButton = false, showTomorrowWithMundial = true, showQuickDates = true, worldCupButtonIcon }) => {
  // Show Tomorrow button always, and Mundial button additionally when showMundialButton is true
  // The showTomorrowWithMundial flag controls if Tomorrow is shown when Mundial is active (for future flexibility)
  // showQuickDates suppresses Today and Tomorrow while the first days are blocked (first-available-date):
  // those shortcuts would land on a blocked date, but "Elegir" only opens the calendar and stays valid
  const shouldShowTomorrow = showQuickDates && (!showMundialButton || showTomorrowWithMundial);

  return (
    <div className="dates-controls-container">
      <label className="label">{label}</label>
      <div className="dates-controls-wrapped">
        {showQuickDates && <DateOption label={<Text id="label.today" />} onClick={onTodayClick} />}
        {shouldShowTomorrow && <DateOption label={<Text id="label.tomorrow" />} onClick={onTomorrowClick} />}
        {showMundialButton && <MundialButton onClick={onMundialClick} icon={worldCupButtonIcon} />}
        <DateOption label={<Text id="label.select" />} icon="calendar" onClick={onDateClick} />
      </div>
    </div>
  );
};

export default DatesControls;
